export default __webpack_public_path__ + "static/media/icn_close.d9bb8e65.svg";